import { render } from "./CourseOutherInfo.vue?vue&type=template&id=51f185a8&scoped=true"
import script from "./CourseOutherInfo.vue?vue&type=script&lang=js"
export * from "./CourseOutherInfo.vue?vue&type=script&lang=js"

import "./CourseOutherInfo.vue?vue&type=style&index=0&id=51f185a8&scoped=true&lang=scss"

import exportComponent from "D:\\work\\ocs\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51f185a8"]])

export default __exports__